import "./DatatableProducts.css";
import { DataGrid } from "@mui/x-data-grid";
import { productsColumns } from "../../datatablesource";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";

// Import des icônes
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";

const DatatableProducts = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
        try {
          const response = await axios.get("http://localhost:5000/api/products/products/all");
          
          // Ajouter l'ID Firebase à chaque utilisateur
          const productsWithSequentialIds = response.data.map((product, index) => ({
            ...product,
            id: index + 1, // ID séquentiel pour l'affichage
            firebaseId: product.id, // Ajout de l'ID Firebase réel
          }));
    
          setData(productsWithSequentialIds);
          setLoading(false);
        } catch (err) {
          console.error("Error fetching produits:", err);
          setError("Erreur lors de la récupération des produits.");
          setLoading(false);
        }
      };
    
      fetchProducts();
    }, []);
  

  const handleDelete = async (productId) => {
    try {
      // Trouver l'utilisateur réel avec l'ID Firebase
      const productToDelete = data.find((product) => product.id === productId); 
      if (productToDelete) {
        const firebaseId = productToDelete.firebaseId; // Assurez-vous que 'firebaseId' est l'ID Firebase réel
  
        // Effectuer la requête DELETE avec l'ID Firebase
        const response = await axios.delete(`http://localhost:5000/api/products/delete/${firebaseId}`);
        alert('Produit supprimé avec succès!');
  
        // Rafraîchir les données après la suppression
        setData(data.filter((product) => product.id !== productId));
      }
    } catch (error) {
      console.error('Erreur lors de la suppression de l\'Produit :', error);
      alert('Erreur lors de la suppression de l\'Produit.');
    }
  };

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            {/* Icône pour "Voir" */}
            <Link to={`/admin/products/${params.row.id}`} style={{ textDecoration: "none" }}>
              <VisibilityIcon
                className="viewIcon"
                style={{ color: "#9caf7d", cursor: "pointer", marginRight: "10px" }}
                titleAccess="Voir"
              />
            </Link>

            {/* Icône pour "Supprimer" */}
            <DeleteIcon
              className="deleteIcon"
              style={{ color: "#d32f2f", cursor: "pointer" }}
              titleAccess="Supprimer"
              onClick={() => handleDelete(params.row.id)}
            />
          </div>
        );
      },
    },
  ];

  if (loading) {
    return <div>Chargement des produits...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="datatable">
      <div className="datatableTitle">
        Ajouter un nouveau produit
        <Link to="/admin/products/newProduct" className="link">
          Ajouter
        </Link>
      </div>
      <DataGrid
        className="datagrid"
        rows={data}
        columns={productsColumns.concat(actionColumn)}
        pageSize={9}
        rowsPerPageOptions={[9]}
        checkboxSelection
        getRowId={(row) => row.id}
      />
    </div>
  );
};

export default DatatableProducts;
